export enum InvoiceStatus {
  Complete = "complete",
  Pending = "pending",
  Voided = "voided",
}
